export const state = () => ({
    isDetailsSectionOpen: null,
});

export const mutations = {
    setIsDetailsSectionOpen(state, payload) {
        state.isDetailsSectionOpen = payload;
    },
};
